<app-loader [isLoading]="isLoading"></app-loader>
<div class="d-flex justify-content-end gap-2" style="margin-bottom: 1rem;">
    <button class="dp-primary-btn btn-div d-flex gap-2 align-items-center" (click)="onFilterClick()">
        Filter<img src="../../../assets/filter.svg" />
    </button>
</div>
@if (!isMobile) {
@if(showReportType === 'ALL'){
<div class="table-container">
    <table class="table">
        <thead class="table-head">
            <tr>
                <th>
                    <span>Country</span>
                </th>
                <th>
                    <span>Total Active Workers</span>
                </th>
                <th>
                    <span>Total Inactive Workers</span>
                </th>

            </tr>
        </thead>

        <tbody class="table-body">
            @for(row of userReport; track row){
            <tr>
                <td (click)="onCountryClick(row?.country)" class="hover-item">
                    {{row?.country}}
                </td>
                <td>
                    {{row?.totalActiveWorkers}}
                </td>
                <td>
                    {{row?.totalInactiveWorkers}}
                </td>
            </tr>
            }
        </tbody>

    </table>

</div>
}@else if(showReportType === 'COUNTRIES'){
<div class="table-container">
    <table class="table">
        <thead class="table-head">
            <tr>
                <th>
                    <span>State</span>
                </th>
                <th>
                    <span>Total Active Workers</span>
                </th>
                <th>
                    <span>Total Inactive Workers</span>
                </th>

            </tr>
        </thead>

        <tbody class="table-body">
            @for(row of userReport; track row){
            <tr>
                @if(row?.state == "ALL"){
                <td>
                    {{row?.state}}
                </td>
                <td (click)="onStateClick(row?.state, 'active')" class="hover-item">
                    {{row?.totalActiveWorkers}}
                </td>
                <td (click)="onStateClick(row?.state, 'inactive')" class="hover-item">
                    {{row?.totalInactiveWorkers}}
                </td>
                }@else {
                <td (click)="onStateClick(row?.state)" class="hover-item">
                    {{row?.state}}
                </td>
                <td>
                    {{row?.totalActiveWorkers}}
                </td>
                <td>
                    {{row?.totalInactiveWorkers}}
                </td>
                }
            </tr>
            }
        </tbody>

    </table>

</div>
}@else if(showReportType === 'STATES'){
<div class="table-container">
    <table class="table">
        <thead class="table-head">
            <tr>
                <th>
                    <span>District</span>
                </th>
                <th>
                    <span>Total Active Workers</span>
                </th>
                <th>
                    <span>Total Inactive Workers</span>
                </th>

            </tr>
        </thead>

        <tbody class="table-body">
            @for(row of userReport; track row){
            <tr>
                @if(row?.district === "ALL"){
                <td>
                    {{row?.district}}
                </td>
                <td class="hover-item" (click)="onDistrictClick(row?.district, 'active')">
                    {{row?.totalActiveWorkers}}
                </td>
                <td class="hover-item" (click)="onDistrictClick(row?.district, 'inactive')">
                    {{row?.totalInactiveWorkers}}
                </td>
                }@else {
                <td>
                    {{row?.district}}
                </td>
                <td class="hover-item" (click)="onDistrictClick(row?.district, 'active')">
                    {{row?.totalActiveWorkers}}
                </td>
                <td class="hover-item" (click)="onDistrictClick(row?.district, 'inactive')">
                    {{row?.totalInactiveWorkers}}
                </td>
                }
            </tr>
            }
        </tbody>

    </table>

</div>
}@else if(showReportType === 'DISTRICTS'){
<div class="table-container">
    <table class="table">
        <thead class="table-head">
            <tr>
                <th>
                    <span>Name</span>
                </th>
                <th>
                    <span>Family Code</span>
                </th>
                <th>
                    <span>Email</span>
                </th>
                <th>
                    <span>Last Login Date</span>
                </th>
                <th>
                    <span>Role</span>
                </th>
                <th>
                    <span>Status</span>
                </th>


            </tr>
        </thead>

        <tbody class="table-body">
            @for(row of userReport; track row){
            <tr>
                <td>
                    {{row?.userName}}
                </td>
                <td>
                    {{row?.family_code}}
                </td>
                <td>
                    {{row?.email}}
                </td>
                <td>
                    {{row?.lastLoginDate}}
                </td>
                <td>
                    {{row?.roleName}}
                </td>
                <td>
                    {{row?.WorkerStatus}}
                </td>

            </tr>
            }
        </tbody>

    </table>

</div>
}
}@else {
@if(showReportType === 'ALL'){

@for(row of userReport;track row;){
<div class="dp-card">
    <div class="heading d-flex justify-content-between">
        <span class="card-title hover-item">{{ row.country }}</span>
        <img src="../../../../../assets/images/dashboard-mob.svg" (click)="onCountryClick('India')">
    </div>
    <div class="mob-details-div">
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total Active Workers</span>
            <span class="card-text-right">{{ row.totalActiveWorkers }}</span>
        </div>
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total Inactive Workers</span>
            <span class="card-text-right">{{ row.totalInactiveWorkers }}</span>
        </div>
    </div>
</div>
}
}@else if(showReportType === 'COUNTRIES'){
@for(row of userReport;track row;){
<div class="dp-card">
    @if(row?.state !== "ALL"){
    <div class="heading d-flex justify-content-between">
        <span class="card-title hover-item" (click)="onStateClick(row?.state)">{{row?.state}}</span>
        <img src="../../../../../assets/images/dashboard-mob.svg" (click)="onStateClick(row?.state)">
    </div>
    <div class="mob-details-div">
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total Active Workers</span>
            <span class="card-text-right">{{row?.totalActiveWorkers}}</span>
        </div>
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total Inactive Workers</span>
            <span class="card-text-right">{{row?.totalInactiveWorkers}}</span>
        </div>
    </div>
    }@else{
    <div class="heading d-flex justify-content-between">
        <span class="card-title ">{{row?.state}}</span>
        <img src="../../../../../assets/images/dashboard-mob.svg">
    </div>
    <div class="mob-details-div">
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total Active Workers</span>
            <span class="card-text-right hover-item"
                (click)="onStateClick(row?.state, 'active')">{{row?.totalActiveWorkers}}</span>
        </div>
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total Inactive Workers</span>
            <span class="card-text-right hover-item"
                (click)="onStateClick(row?.state, 'inactive')">{{row?.totalInactiveWorkers}}</span>
        </div>
    </div>
    }
</div>
}
}
@else if(showReportType === 'STATES'){
@for(row of userReport;track row;){
<div class="dp-card">
    <div class="heading d-flex justify-content-between">
        <span class="card-title">{{row?.district}}</span>
    </div>
    <div class="mob-details-div">
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total Active Workers</span>
            <span class="card-text-right hover-item"
                (click)="onDistrictClick(row?.district, 'active')">{{row?.totalActiveWorkers}}</span>
        </div>
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total Active Workers</span>
            <span class="card-text-right hover-item"
                (click)="onDistrictClick(row?.district, 'inactive')">{{row?.totalInactiveWorkers}}</span>
        </div>
    </div>
</div>
}
}
@else if(showReportType === 'DISTRICTS'){
@for(row of userReport;track row;){
<div class="dp-card">
    <div class="heading d-flex justify-content-between">
        <span class="card-title">{{row?.userName}}</span>
    </div>
    <div class="mob-details-div">
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Family Code</span>
            <span class="card-text-right">{{row?.family_code}}</span>
        </div>
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Email</span>
            <span class="card-text-right ">{{row?.email}}</span>
        </div>
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Last Login Date</span>
            <span class="card-text-right">{{row?.lastLoginDate}}</span>
        </div>
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Role</span>
            <span class="card-text-right">{{row?.roleName}}</span>
        </div>
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Status</span>
            <span class="card-text-right">{{row?.WorkerStatus}}</span>
        </div>
    </div>
</div>
}
}
}